import { Injectable } from '@angular/core';
import {
  BaseDataSourceServiceV2,
  CompanyDto,
  GetManyV2Dto,
  PageableListV2Dto,
  PriceDto,
  SnackbarService,
} from '@fleet-beat/core';
import { DataAutocompleteStorageParams } from '@fleet-beat/editor';
import { AuthService } from '@fleet-beat/shared';
import { PricesApiService } from '@fleet-beat/api';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PriceListAutocompleteStorageService extends BaseDataSourceServiceV2<
  CompanyDto,
  DataAutocompleteStorageParams<object>
> {
  constructor(
    protected override snackbarService: SnackbarService,
    private authService: AuthService,
    private pricesApiService: PricesApiService,
  ) {
    super(snackbarService);
  }

  protected override getData(
    data: DataAutocompleteStorageParams<{ input: string; include?: string; product?: string }>,
  ): Observable<PageableListV2Dto<PriceDto>> {
    if (!data.extra.product)
      return of({
        data: [],
        offset: 0,
        limit: 0,
        total: 0,
      });
    const params: GetManyV2Dto = {
      ...data.params,
      ...data.extra,
      search: data.params.input,
    };
    return this.pricesApiService.getMany(params, this.authService.authHeaders);
  }

  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  protected override getById(id: string): Observable<CompanyDto> {
    throw new Error('Not Implemented');
  }
}
